var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8998 68.7333L1.6665 78.3333L11.2665 59.0999L66.6665 3.66658C67.3012 3.03186 68.0548 2.52837 68.8841 2.18486C69.7134 1.84135 70.6022 1.66455 71.4998 1.66455C72.3975 1.66455 73.2863 1.84135 74.1156 2.18486C74.9449 2.52837 75.6984 3.03186 76.3332 3.66658C76.9679 4.30131 77.4714 5.05483 77.8149 5.88414C78.1584 6.71344 78.3352 7.60228 78.3352 8.49992C78.3352 9.39755 78.1584 10.2864 77.8149 11.1157C77.4714 11.945 76.9679 12.6985 76.3332 13.3332L20.8998 68.7333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5331 18.0666L61.9331 8.46655",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8999 68.7332L11.2666 59.0999",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3333 78.3333L60 60",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5664 56.0666C45.4331 64.9 55.1997 64.8 59.9997 60C63.7997 56.2 64.9331 48.4 61.0331 39.1333",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9332 23.3332C43.3132 19.9907 39.307 17.0924 34.9998 14.6998V21.6665C34.9998 21.6665 30.3332 20.4998 28.8332 11.3665C20.1385 7.19974 11.034 3.9489 1.6665 1.6665C1.6665 1.6665 6.8665 24.9998 18.6332 41.0998",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUi);
export default __webpack_public_path__ + "static/media/UI.4c91b3e252a5a00dcc060aeae142027e.svg";
export { ForwardRef as ReactComponent };